import { NotificationService } from '@acenv/commons-lib';
import { HttpEvent, HttpEventType } from '@angular/common/http';
import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ALL_EXTENSIONS } from 'src/app/shared/constants/fileextensions.constants';

@Component({
    selector: 'lib-file-uploader',
    templateUrl: './file-uploader.component.html',
    styleUrls: ['./file-uploader.component.scss'],
})
export class FileUploaderComponent implements OnInit {
    /** Le fichier doit-il être une image ? */
    @Input() isImage = false;

    /** Upload en cours ? */
    @Input() uploadRunning: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

    /** Pourcentage d'upload */
    @Input() uploadProgress: BehaviorSubject<number> = new BehaviorSubject<number>(0);

    /** Type de fichiers acceptés */
    @Input() acceptedFileExtensions: Array<string>;

    @Output() startUpload = new EventEmitter<any>();

    @Output() uploadFinished = new EventEmitter<boolean>();

    @ViewChild('fileUpload') fileUpload: ElementRef;

    hasExtensionError: boolean = false;

    accept: string = '';

    constructor(private readonly notificationService: NotificationService) {}

    ngOnInit() {
        if (!this.acceptedFileExtensions) {
            this.acceptedFileExtensions = ALL_EXTENSIONS;
        }
        // Transformation des extensions de fichiers à insérer dans l'input accept
        const fileExtensions = this.acceptedFileExtensions.map((ext) => '.' + ext);
        this.accept = fileExtensions.join(',');
    }

    selectFile() {
        this.fileUpload.nativeElement.click();
    }

    uploadFile() {
        const formData = new FormData();
        const fileName = this.fileUpload.nativeElement.files[0].name as string;
        /** Si aucune extension n'est spécifiée, on accepte toutes les extensions disponibles */
        let acceptedType = '';
        // Concaténation des types de fichiers acceptés pour affichage dans l'erreur
        acceptedType = this.acceptedFileExtensions.join(', ');
        for (const extension of this.acceptedFileExtensions) {
            if (fileName.toLowerCase().endsWith('.' + extension)) {
                formData.append('file', this.fileUpload.nativeElement.files[0]);
                this.startUpload.emit(formData);
                this.uploadProgress.next(0);
                this.uploadRunning.next(true);
                this.hasExtensionError = false;
                return;
            } else {
                this.hasExtensionError = true;
            }
        }
        if (this.hasExtensionError) {
            this.notificationService.error('Type(s) de fichier accepté(s): ' + acceptedType.slice(0, -1));
        }
    }

    public uploadFileData(data: any) {
        const formData = new FormData();
        formData.append('file', data);
        this.startUpload.emit(data);
        this.uploadProgress.next(0);
        this.uploadRunning.next(true);
    }

    handleUploadFileServiceCall(callback: Observable<HttpEvent<any>>) {
        callback
            .pipe(
                map((event) => {
                    switch (event.type) {
                        case HttpEventType.UploadProgress:
                            this.uploadProgress.next(Math.round((event.loaded * 100) / event.total));
                            break;
                        case HttpEventType.Response:
                            this.uploadProgress.next(100);
                            this.uploadRunning.next(false);
                            this.uploadFinished.emit(true);
                            // Il faut réinitialiser la valeur du l'input pour pouvoir uploader 2x le même fichier (sinon l'évènement change n'est pas déclenché)
                            this.fileUpload.nativeElement.value = null;
                            return event;
                    }
                }),
                catchError((err) => {
                    this.uploadProgress.next(100);
                    this.uploadRunning.next(false);
                    this.uploadFinished.emit(false);
                    console.error('FileUploaderComponent: upload failed : ', err);
                    return of('File upload failed !');
                }),
            )
            .subscribe(() => {});
    }
}
